import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
    Box,
    Button,
    Input,
    Heading,
    FormControl,
    FormLabel,
    useToast
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { SupabaseClient } from '../../supabaseClient';

const RegisterPage = () => {
    const { t } = useTranslation();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const toast = useToast();
    const navigate = useNavigate();

    const handleRegister = async (e) => {
        e.preventDefault();
        // Validation
        if (!email.trim() || !password || !confirmPassword) {
            return toast({
                title: t('register.toast.allFieldsRequired'),
                status: 'error',
                duration: 3000,
                isClosable: true,
            });
        }
        if (password !== confirmPassword) {
            return toast({
                title: t('register.toast.passwordsMismatch'),
                status: 'error',
                duration: 3000,
                isClosable: true,
            });
        }

        setIsLoading(true);
        try {
            const { error } = await SupabaseClient.auth.signUp(
                { email, password },
                { emailRedirectTo: 'https://onmom.vercel.app/login' }
            );

            if (error) {
                toast({
                    title: t('register.toast.errorTitle'),
                    description: error.message,
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                });
            } else {
                toast({
                    title: t('register.toast.successTitle'),
                    description: t('register.toast.checkEmail'),
                    status: 'success',
                    duration: 3000,
                    isClosable: true,
                });
                setEmail('');
                setPassword('');
                setConfirmPassword('');
                navigate('/login');
            }
        } catch (err) {
            toast({
                title: t('register.toast.unexpectedErrorTitle'),
                description: err.message || t('register.toast.unexpectedErrorDescription'),
                status: 'error',
                duration: 3000,
                isClosable: true,
            });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Box maxW="500px" mx="auto" p={4}>
            <Heading textAlign="center" mb={4}>{t('register.title')}</Heading>
            <form onSubmit={handleRegister}>
                <FormControl isRequired mb={4}>
                    <FormLabel>{t('register.form.email.label')}</FormLabel>
                    <Input
                        type="email"
                        placeholder={t('register.form.email.placeholder')}
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                    />
                </FormControl>

                <FormControl isRequired mb={4}>
                    <FormLabel>{t('register.form.password.label')}</FormLabel>
                    <Input
                        type="password"
                        placeholder={t('register.form.password.placeholder')}
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                    />
                </FormControl>

                <FormControl isRequired mb={4}>
                    <FormLabel>{t('register.form.confirmPassword.label')}</FormLabel>
                    <Input
                        type="password"
                        placeholder={t('register.form.confirmPassword.placeholder')}
                        value={confirmPassword}
                        onChange={e => setConfirmPassword(e.target.value)}
                    />
                </FormControl>

                <Button type="submit" colorScheme="blue" isLoading={isLoading} width="full">
                    {t('register.form.submit')}
                </Button>
            </form>
        </Box>
    );
};

export default RegisterPage;